module.exports = __webpack_public_path__ + "static/media/videoPython.861d4878.mp4";